// Display helper: turns an API date (yyyy-mm-dd, optionally followed by a time
// part) into the dd/mm/yyyy format used across the listing screens.
// Anything that is not an ISO date (empty, "N/A", already formatted) is
// returned untouched so the caller can render it as-is.
export function formatDate(value) {
  if (!value) return "";
  const str = String(value).trim();
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return str;
  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
}

export default formatDate;
